import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const VerifiedFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M17.63 16.81s-.09.02-.14.02c-.05 0-.09 0-.14-.02-2.53-.67-3.92-2.14-4.65-3.96H2v5.22C2 19.13 2.87 20 3.93 20h13.56c1.06 0 1.93-.87 1.93-1.93v-1.96c-.52.28-1.11.52-1.78.7h-.01Z"
        fill={color}
      />
      <Path
        d="M21.78 7.53a.35.35 0 0 0-.14-.28.406.406 0 0 0-.3-.1c-2 .13-3.54-1.28-3.56-1.29a.408.408 0 0 0-.57.02c-1.32 1.39-3.49 1.28-3.51 1.28-.11 0-.22.03-.3.1a.42.42 0 0 0-.14.28c-.17 3.31.19 6.83 4.15 7.88.03 0 .07.01.1.01s.07 0 .1-.01c3.96-1.05 4.32-4.58 4.15-7.88l.02-.01Zm-2.06 2.34-2.4 2.4c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19l-1.14-1.14a.658.658 0 0 1 0-.92c.25-.25.67-.25.92 0l.68.68 1.94-1.94c.25-.25.67-.25.92 0s.25.67 0 .92Z"
        fill={color}
      />
      <Path
        d="M11.97 7.81H3.93C2.87 7.81 2 8.68 2 9.74v1.92h10.33c-.29-1.21-.38-2.53-.36-3.85Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default VerifiedFilled
